import React, { FC, ReactNode } from 'react'
import styles from './index.module.scss'

type Props = {
  icon: ReactNode
  nameList: string[]
  suffix?: string
}

export const IconTextItem: FC<Props> = ({ icon, nameList, suffix }) => {
  const text = nameList?.join(', ')
  return (
    <div className={styles.container}>
      <div className={styles.icon}>{icon}</div>
      <p className={styles.nameList}>
        <span className={styles.name}>{text}</span>
        {suffix && <div className={styles.suffix}>{suffix}</div>}
      </p>
    </div>
  )
}
